// extracted by mini-css-extract-plugin
export default {"cart-summary":"PriceDetails_cart-summary__h1hEV","total-amount":"PriceDetails_total-amount__+Omk9"};